export const authTypes = {
    setUser: '[auth] Sets a user as connected',
    signupUser: '[auth] Signs in a new user',
    logOutUser: '[auth] Logs out an existing user',
}